(function () {
    'use strict';

    angular.module('Services').factory('TableLiteFactory', TableLiteFactoryFn);

    TableLiteFactoryFn.$inject = ['$q', '$filter', '$log'];

    function TableLiteFactoryFn($q, $filter, $log) {
        return function (table, options) {
            // sorting values 
            let timesClicked = 0;
            let prevSortFilterName = ""; 
            let direction = "";

            let tableData = table;
            let activeFilters = {};
            let paginationFilter = angular.extend({size: 20, page: 0}, options.defaultFilters);
            let sortingFilter = {
                page: 0
            };

            function addTableEssentials() {
                tableData.onPageChanged = tableData.onPageChanged || function (currentPage) {
                    sendRequest({
                        page: currentPage - 1
                    });
                };

                tableData.resetFilters = tableData.resetFilters || resetFilters;
                tableData.applyFilters = tableData.applyFilters || function (item) {
                    console.log('table lite factory');
                    angular.extend(paginationFilter, {
                        size: item,
                        page: 0
                    });
                    sendRequest(paginationFilter);
                };
                tableData.onInit = tableData.onInit || function () {
                    sendRequest({});
                };
                tableData.headers.forEach(header => {
                    header.filterName = header.filterName || header.viewName;
                });
            }

            function initializeTableData(data) {
                if (!data) {
                    data = { content: [] };
                    tableData.sort = null;
                    tableData.totalItems = 0;
                    tableData.numberOfItems = 0;
                    tableData.itemView = angular.getObjVal(options, 'defaultFilters.size') || 20;
                    tableData.itemViewRaw = 0;
                    tableData.currentPage = 1;
                    return false;
                }
                if (!angular.isNumber(data.totalElements) && !angular.isNumber(data.numberOfElements)
                    && !angular.isNumber(data.size) && !angular.isNumber(data.number)) {
                        tableData.totalItems = angular.getObjVal(data, 'data.length');
                        tableData.numberOfItems = angular.getObjVal(data, 'data.length');
                        tableData.itemViewRaw = angular.getObjVal(data, 'data.length');
                        tableData.itemView = angular.getObjVal(data, 'data.length');
                        tableData.currentPage = 1;

                        return true;
                }

                tableData.sort = data.sort;
                tableData.totalItems = data.totalElements;
                tableData.numberOfItems = data.numberOfElements;
                tableData.itemView = data.size;
                tableData.itemViewRaw = angular.copy(data.size);
                tableData.currentPage = data.number + 1;

                return true;
            }

            function sort(filterName) {
                const defer = $q.defer();

                direction = '';
                if(prevSortFilterName == filterName) {
                    timesClicked +=1;
                    if(timesClicked >= 3) {
                        timesClicked = 0;
                        direction = '';
                        sortingFilter.sort = options.defaultFilters.sort;
                    } 
                    else {
                        if(timesClicked == 1) {
                            direction = 'asc';
                        }
                        else {
                            direction = 'desc';
                        }
                        sortingFilter.sort = filterName + ',' + direction;
                    }
                } 
                else {
                    prevSortFilterName = filterName;
                    timesClicked = 1;
                    direction = 'asc';
                    sortingFilter.sort = filterName + ',' + direction;
                }
                
                sendRequest(sortingFilter).then(data => {
                    defer.resolve(data);
                }).catch(error => {
                    defer.reject(error);
                });
                return defer.promise;
            }

            function resetFilters() {
                const defer = $q.defer();
                angular.forEach(tableData.headers, function (header) {
                    if (header.filter) {
                        if (header.filter.model)
                            header.filter.model = '';
                        if (header.filter.toModel) {
                            header.filter.toModel = '';
                            delete activeFilters.endDate;
                        }

                        if (header.filter.fromModel) {
                            header.filter.fromModel = '';
                            delete activeFilters.startDate;
                        }
                        delete activeFilters[header.filterName];
                    }
                });

                sendRequest({}).then(data => {
                    defer.resolve(data);
                }).catch(error => {
                    defer.reject(error);
                });
                return defer.promise;
            }

            function sendRequest(filter) {
                if(angular.getObjVal(tableData, 'tableName')){
                    if(angular.getObjVal(filter, 'page') == null){
                        let savedPageData = angular.fromJson(localStorage.getItem(`${tableData.tableName}_pageData`));
                        if(filter) {
                            angular.extend(filter, savedPageData);
                        }
                    }
                }

                const defer = $q.defer();
                tableData.isFetching = true;
                if (tableData.data) {
                    tableData.data.length = 0;
                }
                if (filter) {
                    filter = sanitizeFilters(filter);
                    delete activeFilters.page;
                    activeFilters = angular.extend(activeFilters, filter);
                }

                const format = {
                    success: data => {
                        if (angular.getObjVal(data, 'sort.directive')) { 
                            data.sort.direction = direction;
                        }

                        if (angular.getObjVal(data, 'sort.filterName')) {
                            data.sort.filterName = prevSortFilterName;
                        }
                        
                        tableData.isAllSelected = false;
                        if (tableData.data)
                            tableData.data.length = 0;
                        try {
                            options.postRequestCallback(data);
                        } catch (e) {
                            $log.error(e);
                        }
                        tableData.isFetching = false;

                        // save the current page
                        if(angular.getObjVal(tableData, 'tableName')){
                            var pageData = { 
                                page: angular.copy(data.number),
                                size: angular.copy(data.size)
                            }
                            localStorage.setItem(`${tableData.tableName}_pageData`, angular.toJson(pageData));
                        }
                        $q.resolve(data);
                    },
                    error: err => {
                        tableData.isAllSelected = false;
                        try {
                            options.postRequestErrorCallback(err);
                        } catch (e) {
                            $log.error(e);
                        }
                        tableData.isFetching = false;
                        $q.reject(err);
                    },

                    filter: angular.extend({}, paginationFilter, activeFilters),
                    id: options.paramId,
                    options: options.options
                };
                options.serviceCallback(format[options.callbackFormat[0]], format[options.callbackFormat[1]], format[options.callbackFormat[2]], format[options.callbackFormat[3]], format[options.callbackFormat[3]]);

                return defer.promise;
            }

            function updateDefaultFilter(filters) {
                // todo: test this code 
                paginationFilter = angular.extend(paginationFilter, filters);
            }

            function sanitizeFilters(filterList) {
                const filterClean = {};
                angular.forEach(filterList, function (item, key) {
                    if (_.has(item, 'value'))
                        filterClean[key] = item.value;
                    else
                        filterClean[key] = item;
                });

                return filterClean;
            }

            function evaluateFilter(header) {
                const filter = {};
                if (header.filter.type === 'date' || header.filter.type === 'datePicker') {
                    if (!header.filter.fromModel && header.filter.toModel) {
                        header.filter.fromModel = header.filter.toModel;
                    }

                    const dateFormat = header.filter.format || "yyyy-MM-dd";
                    if (header.filter.fromModel) {
                        filter.startDate = encodeURIComponent($filter('date')(new Date(header.filter.fromModel), dateFormat));
                    }

                    if (header.filter.toModel) {
                        filter.endDate = encodeURIComponent($filter('date')(new Date(header.filter.toModel), dateFormat));
                    }
                   
                    if (header.filter.useArray) {
                        filter[header.filterName] = [
                            filter.startDate, filter.endDate
                        ];
                        if (!filter[header.filterName].filter(filter => filter).length)
                            delete filter[header.filterName];
                        delete filter.startDate;
                        delete filter.endDate;
                    }

                    if (!header.filter.fromModel) {
                        delete activeFilters['startDate'];
                    }

                    if (!header.filter.toModel) {
                        delete activeFilters['endDate'];
                    }

                    if (angular.getObjVal(header, 'filter.startDateFilter') && angular.getObjVal(header, 'filter.endDateFilter')) {
                        filter[header.filter.startDateFilter] = encodeURIComponent($filter('date')(new Date(header.filter.fromModel), "yyyy-MM-dd HH:mm:ss Z"));;
                        filter[header.filter.endDateFilter] = encodeURIComponent($filter('date')(new Date(header.filter.toModel), "yyyy-MM-dd HH:mm:ss Z"));;
                        
                        delete filter.startDate;
                        delete filter.endDate; 
                        delete filter[header.filterName]
                    }
                    
                } else if (header.filter.type === 'multipleSelect') {
                    if (header.filter.model) {
                        if (angular.getObjVal(header, 'filter.filterBy')) {
                            filter[header.filterName] = header.filter.model.map(item => item[header.filter.filterBy]);
                        } else {
                            filter[header.filterName] = header.filter.model;
                        }
                    }
                } else if(header.filter.type === 'chipText'){
                    if (header.filter.model) {
                        if (angular.getObjVal(header, 'filter.filterBy')) {
                            filter[header.filterName] = header.filter.model.map(item => item[header.filter.filterBy]);
                        } else {
                            filter[header.filterName] = header.filter.model;
                        }
                    }
                
                } else if (header.filter.model) {
                    if (angular.getObjVal(header, 'filter.filterBy')) {
                        filter[header.filterName] = header.filter.model[header.filter.filterBy];
                    } else {
                        filter[header.filterName] = encodeURIComponent(header.filter.model);
                    }
                } else if (activeFilters[header.filterName])
                    delete activeFilters[header.filterName];

                return filter;
            }

            addTableEssentials();
            this.initializeTableData = initializeTableData;
            this.sort = sort;
            this.sendRequest = sendRequest;
            this.evaluateFilter = evaluateFilter;
            this.sanitizeFilters = sanitizeFilters;
            this.resetFilters = resetFilters;
            this.activeFilters = activeFilters;
            this.getCommonProperties = initializeTableData;
            this.updateDefaultFilter = updateDefaultFilter;
        };
    }

})();



// WEBPACK FOOTER //
// ./js/services/tables/TableLiteFactory.js